import Table from "components/general/Table";
import ButtonV2 from "components/individual/ButtonsV2/Button";
import { Search } from "components/individual/Search";
import usePartialitiesReport from "customHooks/usePartialitiesReport";
import { parseDateToText, parseDateToTextAndTime } from "helpers/dates";
import { parseToFolio } from "helpers/documents";
import { mnCurrency } from "helpers/money";
import React from "react";
import ui from "./styles.module.scss";

/**
 * Render partialities report
 * @param {import("./types").PropsPartialitiesReport} props 
 */
export default function PartialitiesReport({ type = "cxc" }) {
  const { hook, parsedData, retrieveReport } = usePartialitiesReport(type);

  return (
    <div className={ui.container}>
      <form className={ui.formSearch}>
        <Search placeholder="Escribe aquí" />

        <ButtonV2 type="button" onClick={() => retrieveReport("json")}>
          Buscar
        </ButtonV2>
        <ButtonV2 type="button" onClick={() => retrieveReport("excel")}>
          Excel
        </ButtonV2>
      </form>

      <TableReport
        data={parsedData || []}
        progressPending={hook.loading}
        title={type==="cxc" ? "Cuentas por cobrar" : "Cuentas por pagar"}
        pagination={false}
        columns={[
          {
            name: "No. factura",
            selector: (invoice) => parseToFolio(invoice.factura.folio),
            center: true,
            sortable: true,
          },
          {
            name: "Parcialidad",

            selector: (invoice) =>
              `${invoice.parcialidades[0].parcialidad}/${invoice.parcialidades[0].parcialidades}`,
            center: true,
          },

          {
            name: "Fecha emisión",
            selector: (invoice) =>
              parseDateToTextAndTime(invoice.factura.emision, "medium"),
            center: true,
            sortable: true,
          },
          {
            name: "Vencimiento",
            cell: (invoice) => (
              <p className="d-flex justify-content-center align-items-center w-100 m-0">
                {parseDateToText(invoice.parcialidades[0].expiracion)}
              </p>
            ),

            center: true,
            sortable: true,
          },
          {
            name: "Ejecutivo",
            selector: (invoice) => invoice.ejecutivo.nombre,
            center: true,
            sortable: true,
          },
          {
            name: "Razón social",
            selector: (invoice) => invoice.directorio.razonSocial,
            sortable: true,
          },
          {
            name: "Moneda",
            center: true,
            cell: (invoice) => (
              <p className="d-flex justify-content-center align-items-center w-100 m-0">
                {invoice.factura.moneda}
              </p>
            ),
            sortable: true,
          },
          {
            name: "Total",
            cell: (invoice) => (
              <p className="d-flex justify-content-end align-items-center w-100 m-0">
                {mnCurrency(invoice.parcialidades[0].total)}
              </p>
            ),
          },
          {
            cell: (invoice) => (
              <p className="d-flex justify-content-end align-items-center w-100 m-0">
                {mnCurrency(invoice.parcialidades[0].saldo)}
              </p>
            ),
            name: "Saldo",
            //   selector: (invoice) => mnCurrency(invoice.parcialidades[0].saldo),
          },
          {
            name: "Estatus",
            selector: (invoice) => invoice.parcialidades[0].estatus,
            sortable: true,
          },
        ]}
      />
    </div>
  );
}

/**
 * 
 * @param {import("react-data-table-component").TableProps<import("customHooks/usePartialitiesReport/types").PartialitieReportItem>} props 

 */
function TableReport(props) {
  return <Table {...props} />;
}
